module.exports = __webpack_public_path__ + "top_page/top-industry-medical-435de236e153e24d736ee0310a2dc7a4.svg";